import React from 'react';
import { usePermissions } from '../contexts/PermissionsContext';

const RequireRole: React.FC<{
  role: string | string[];
  requireAny?: boolean;
  DeniedComponent?: React.FC<{
    role: string | string[];
  }>;
}> = ({ children, role, requireAny = false, DeniedComponent }) => {
  const { hasRole } = usePermissions();
  const allow = hasRole(role, requireAny);
  if (!allow) {
    if (DeniedComponent) {
      return <DeniedComponent role={role} />;
    }
    return null;
  }
  return <>{children}</>;
};

export default RequireRole;
